export default {"src":"/_next/static/media/insurance.a08e4000.svg","height":312,"width":302,"blurWidth":0,"blurHeight":0};